import axios from 'axios';

export default {
    fetchExportableProducts() {
        return axios.post('/cuttingPleating/fetchExportableProducts');
    },
    importCsv(formData) {
        return axios.post('/cuttingPleating/importCsv', formData);
    },
    exportCuttingPleatingCsv() {
        return axios.post('/export/cuttingPleatingCsv');
    },
    fetchProductsToValidate(filters) {
        let queryString = '';
        if (filters) {
            queryString = Object.keys(filters)
                .filter((key) => filters[key] !== null)
                .map((key) => key + '=' + filters[key])
                .join('&');
        }

        return axios.get(
            `[API]/cutting-pleating-validation/products-to-validate${
                queryString ? '?' + queryString : ''
            }`
        );
    },
    fetchProductToValidate(productId) {
        return axios.get(
            `[API]/cutting-pleating-validation/products-to-validate/${productId}`
        );
    },
    fetchDeliveryMethodOptions() {
        return axios.get(
            '[API]/cutting-pleating-validation/filters/delivery-methods'
        );
    },
    fetchProductTypeOptions() {
        return axios.get(
            '[API]/cutting-pleating-validation/filters/product-types'
        );
    },
    saveAndProcessProduct(productId, employeeId, unfoldment) {
        return axios.post(
            `[API]/cutting-pleating-validation/products-to-validate/${productId}`,
            {
                employeeId,
                unfoldment,
            }
        );
    },
    getDxfJson(productId, config = null) {
        return axios.get(
            `[API]/cutting-pleating-validation/products-to-validate/${productId}/dxf-json`,
            config
        );
    },
};
